import React from 'react'
import './updateBR.css'
import axios from 'axios'

class UpdateBR extends React.Component {
  constructor(props){
    super(props);
    this.state = {patientName: '', patientContact: '', bloodGroup: '', bloodQuantity: '', hospitalName: '', hospitalAddress: '', email: '', requestComplete: ''};
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const urlPathname = window.location.pathname
    const urlID = urlPathname.split('/')
    axios.get('https://blood147.000webhostapp.com/admin_panel/selectBloodRequests.php/?id=' + urlID[2])
    .then(response => response.data)
    .then((data) => {
      // handle success
      data.map(request => {
        this.setState({ patientName: request.patientName, patientContact: request.patientContact, bloodGroup: request.bloodGroup, bloodQuantity: request.bloodQuantity, hospitalName: request.hospitalName, hospitalAddress: request.hospitalAddress, email: request.email, requestComplete: request.requestComplete })
        if (this.state.requestComplete === 'true') {
          document.getElementById("requestTrue").checked = true
        }
        else if (this.state.requestComplete === 'false') {
          document.getElementById("requestFalse").checked = true
        }
      })
    })
    .catch(function (error) {
      // handle error
      console.log(error);
    })
    .then(function () {
      // always executed
    });
  }

  handleChange(e){
    const state = this.state
    state[e.target.name] = e.target.value
    this.setState(state);
  }

  handleSubmit(e){
    e.preventDefault()

    const checkPatientName = document.getElementById('patientName').value
    const checkPatientContact = document.getElementById('patientContact').value
    const checkBloodGroup = document.getElementById('bloodGroup').value
    const checkBloodQuantity = document.getElementById('bloodQuantity').value
    const checkHospitalName = document.getElementById('hospitalName').value
    const checkHospitalAddress = document.getElementById('hospitalAddress').value
    const checkEmail = document.getElementById('email').value

    const regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    const regexName = /^[a-z ,.'-]+$/i

    if (checkPatientName == '' || checkPatientContact == '' || checkBloodGroup == '' || checkBloodQuantity == '' || checkHospitalName == '' || checkHospitalAddress == '' || checkEmail == '') {
      document.getElementById('errorPatientName').style.display = 'block'
      document.getElementById('errorPatientContact').style.display = 'block'
      document.getElementById('errorBloodGroup').style.display = 'block'
      document.getElementById('errorBloodQuantity').style.display = 'block'
      document.getElementById('errorHospitalName').style.display = 'block'
      document.getElementById('errorHospitalAddress').style.display = 'block'
      document.getElementById('errorEmail').style.display = 'block'
      return
    }
    else{
      document.getElementById('errorPatientName').style.display = 'none'
      document.getElementById('errorPatientContact').style.display = 'none'
      document.getElementById('errorBloodGroup').style.display = 'none'
      document.getElementById('errorBloodQuantity').style.display = 'none'
      document.getElementById('errorHospitalName').style.display = 'none'
      document.getElementById('errorHospitalAddress').style.display = 'none'
      document.getElementById('errorEmail').style.display = 'none'
    }

    if(!regexName.test(checkPatientName)){
      document.getElementById('errorPatientName').style.display = 'block'
      return
    }

    if(!regexName.test(checkHospitalName)){
      document.getElementById('errorHospitalName').style.display = 'block'
      return
    }
    
    if(!regexEmail.test(checkEmail)){
      document.getElementById('errorEmail').style.display = 'block'
      return
    }

    this.update() 
  }

  update(){
    const urlPathname = window.location.pathname
    const urlID = urlPathname.split('/')

    let formData = new FormData();
    formData.append('patientName', this.state.patientName)
    formData.append('patientContact', this.state.patientContact)
    formData.append('bloodGroup', this.state.bloodGroup)
    formData.append('bloodQuantity', this.state.bloodQuantity)
    formData.append('hospitalName', this.state.hospitalName)
    formData.append('hospitalAddress', this.state.hospitalAddress)
    formData.append('email', this.state.email)
    formData.append('requestComplete', this.state.requestComplete)

    axios({
      method: 'post',
      url: 'https://blood147.000webhostapp.com/admin_panel/updateBloodRequests.php?id=' + urlID[2],
      data: formData,
      config: { headers: {'Content-Type': 'multipart/form-data' }}
    })
    .then(function (response) {
        if(response.data == 'failed'){
          alert('Update failed!!!\nMake sure your inputs are correct.\nMaybe try again later.')
        }
        else{
          alert('Update successful!!!')
          window.history.go(-1)
        }  
    })
    .catch(function (response) {
        //handle error
        console.log(response)
    });
  }

  render(){
    return (
      <div className="updateBR">
        <div className="updateBRContainer">
          <form className="updateBRForm">
            <div className="updateBRFormDiv">
              <div className="updateBRInputWrapper">
                <label htmlFor="patientName" className='updateBRLabel'>Patient Name:</label>
                <p id='errorPatientName' className='errorMessage'>Please fill in alphabets!</p>
                <input id='patientName' type="text" className="updateBRInput" placeholder="John Cena" name="patientName" value={this.state.patientName} onChange={this.handleChange}/> 
              </div>
              <div className="updateBRInputWrapper">
                <label htmlFor="patientContact" className='updateBRLabel'>Patient Contact:</label>
                <p id='errorPatientContact' className='errorMessage'>Please fill patient contact!</p>
                <input id='patientContact' type="number" className="updateBRInput" placeholder="9812345678" name="patientContact" value={this.state.patientContact} onChange={this.handleChange}/> 
              </div>
            </div>
            
            <div className="updateBRFormDiv">
              <div className="updateBRInputWrapper">
                <label htmlFor="bloodGroup" className='updateBRLabel'>Blood Group:</label>
                <p id='errorBloodGroup' className='errorMessage'>Please select patient's blood group!</p>
                <select id='bloodGroup' className='updateUsersInput' name="bloodGroup" value={this.state.bloodGroup} onChange={this.handleChange}>
                  <option value="" disabled>Choose Blood Group...</option>
                  <option value="A+ve">A+ve</option>
                  <option value="A-ve">A-ve</option>
                  <option value="B+ve">B+ve</option>
                  <option value="B-ve">B-ve</option>
                  <option value="AB+ve">AB+ve</option>
                  <option value="AB-ve">AB-ve</option>
                  <option value="O+ve">O+ve</option>
                  <option value="O-ve">O-ve</option>
                </select>
              </div>
              <div className="updateBRInputWrapper">
                <label htmlFor="bloodQuantity" className='updateBRLabel'>Blood Quantity 'Packets':</label>
                <p id='errorBloodQuantity' className='errorMessage'>Please input required number!</p>
                <input id='bloodQuantity' type="number" placeholder='Number of required packs' className="updateBRInput" name="bloodQuantity" value={this.state.bloodQuantity} onChange={this.handleChange}/> 
              </div>
            </div>
            
            <div className="updateBRFormDiv">
              <div className="updateBRInputWrapper">
                <label htmlFor="hospitalName" className='updateBRLabel'>Hospital Name:</label>
                <p id='errorHospitalName' className='errorMessage'>Please fill in alphabets!</p>
                <input id='hospitalName' type="text" className="updateBRInput" placeholder="Pokhara Regional Hospital" name="hospitalName" value={this.state.hospitalName} onChange={this.handleChange}/> 
              </div>
              <div className="updateBRInputWrapper">
                <label htmlFor="hospitalAddress" className='updateBRLabel'>Hospital Address:</label>
                <p id='errorHospitalAddress' className='errorMessage'>Please fill hospital address!</p>
                <input id='hospitalAddress' type="text" className="updateBRInput" placeholder="Street, City, Country" name="hospitalAddress" value={this.state.hospitalAddress} onChange={this.handleChange}/> 
              </div>
            </div>
            
            <div className="updateBRFormDiv">
              <div className="updateBRInputWrapper">
                <label htmlFor="email" className='updateBRLabel'>Requester Email:</label>
                <p id='errorEmail' className='errorMessage'>Please fill in requester's email!</p>
                <input id='email' type="email" className="updateBRInput" placeholder="johncena10@gmail.com" name="email" value={this.state.email} onChange={this.handleChange}/> 
              </div>
              <div className="updateBRInputWrapper">
                <label className='updateBRLabel'>Request Completion:</label>
                <span className='updateBRSpan' onChange={this.handleChange}>
                  <input id='requestTrue' type="radio" name="requestComplete" value='true'/>
                  <label htmlFor="true" style={{paddingRight: '10px'}}>Complete</label>
                  <input id='requestFalse' type="radio" name="requestComplete" value='false'/>
                  <label htmlFor="false">Pending..</label>
                </span>
              </div>
            </div>

            <div className="addBRFormDiv">
              <div className="addBRSubmitWrapper">
                <input type="submit" className='addBRSubmit' onClick={this.handleSubmit} value="Update" />
              </div>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default UpdateBR